import { CalendarDay, getLiturgicalYear } from "../calendar/utils";

export const getPreviousDay = (day: CalendarDay): CalendarDay => {
    if (day.month === 1 && day.date === 1) {
        const days = getLiturgicalYear(day.year - 1, true).days;
        return days[days.length - 1];
    } else {
        const days = getLiturgicalYear(day.year, true).days;
        let prevDay = days[0];
        let found = false;

        days.forEach((d) => {
            if (!found) {
                if (d.month === day.month && d.date === day.date) {
                    found = true;
                } else {
                    prevDay = d;
                }
            }
        });

        return prevDay;
    }
};

export const getDayString = (day: CalendarDay) => {
    return `${day.year}-${day.month}-${day.date}`;
};
